@if (initialized && dto) {

    <div class="mt-3">
        <bm-billing-area-details
                [billingAreaId]="objectIdentifier.objectId">
        </bm-billing-area-details>
    </div>

}
